import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import dayjs from 'utils/dayjs';

import { getLocaleInURLFormat, parseDate } from 'utils';
import { fetchDiscussions } from 'actions';

import { SectionTitle } from 'components/SectionTitle';
import Icon from 'components/commons/Icon';
import { Wrapper, Comments, Comment, CommentsLink } from './styles';

const DEFAULT_AVATAR = `${process.env.APP_MINFIN_API_DOMAIN}/img/userpics/default.gif`;

const ExchangeDiscussion = () => {
  const { locale, formatMessage } = useIntl();
  const [countAvatars, setCountAvatars] = useState();
  const ref = useRef();

  const { date } = useParams();

  const dispatch = useDispatch();

  const discussions = useSelector(state => state.currency?.discussions || {});

  useEffect(() => {
    dispatch(fetchDiscussions(date));
  }, [date]);

  useEffect(() => {
    const width = ref.current?.offsetWidth;
    if (width) {
      const count = width / 42;
      setCountAvatars(count);
    }
  }, []);

  const firstFifteenAvatars = discussions?.avatars
    ?.slice(0, countAvatars)
    .map((el, i) => (
      <Comment
        key={el.userId}
        zindex={i}
        countAvatars={countAvatars}
        src={`${process.env.APP_MINFIN_API_DOMAIN}${el.avatar}`}
        onError={e => {
          e.target.onerror = null;
          e.target.src = DEFAULT_AVATAR;
        }}
      />
    ));

  const dayURL = `/${(parseDate(date) || dayjs()).format('YYYY/MM/DD')}/`;

  const commentsText = formatMessage({ id: 'comments' });

  return (
    <Wrapper>
      <SectionTitle title="discussion.mainTitle" />

      <Comments ref={ref}>{countAvatars && firstFifteenAvatars}</Comments>

      <CommentsLink
        {...(discussions.totalCount
          ? {
              href: `https://${process.env.APP_DOMAIN}${getLocaleInURLFormat(
                locale
              )}${dayURL}currency/`,
            }
          : {})}
        target="_blank"
      >
        {`${discussions.totalCount} ${commentsText}`}
        <Icon name="vectorStrokeMb" style={{ marginLeft: '10px' }} />
      </CommentsLink>
    </Wrapper>
  );
};

export default ExchangeDiscussion;
